import HttpService from "./HttpService";

let menuService = {
    listarCompleto: () => {
        return HttpService.backApi.get("/menus/funcionalidades")
    },
};

export default menuService;